export const cleanUpExpand = (element: HTMLElement) => {
  Object.assign(element.style, {
    height: null,
    overflow: 'initial',
  });
};
